import { useEffect } from 'react';

// Utils
import { languages } from '../../../languages';
import { textByLang } from '../utils/textByLang';

// Hooks
import { useRouter } from 'next/router';
import { useStore } from 'core/GlobalStore';
import { LangObjType } from '../models/lang.model';

const languagesArr = Object.values(languages);

export const useLangLinks = (
  langObj: {} | undefined,
  propName = 'slug',
  replaceCount = 1
) => {
  const router = useRouter();
  const { asPath = '' } = router;

  const { langLinks = {}, setLangLinks = (langLinks: LangObjType) => {} } = useStore(
    'langModel'
  )('langLinks', 'setLangLinks');

  // useEffect(() => {
  //   const handleBeforeHistoryChange = () => {
  //     setState({ langLinks: {} });
  //   };

  //   if (router && !eventListenerAdded) {
  //     router.events.on('beforeHistoryChange', handleBeforeHistoryChange);

  //     eventListenerAdded = true;
  //   }

  //   return () => {
  //     router.events.off('beforeHistoryChange', handleBeforeHistoryChange);
  //   };
  // }, []);

  type LinksObj = { [key: string]: string };

  useEffect(() => {
    if (langObj) {
      const [pathWithoutParams = '', queryParams = ''] = asPath?.split?.('?');
      const pathArr = pathWithoutParams?.split?.('/');
      const pathArrSlice = pathArr?.slice(0, (pathArr.length || 1) - replaceCount);
      const pathStr = pathArrSlice.join('/');

      const linksObj: LinksObj = {}; // Використовуйте визначений тип LinksObj

      languagesArr.forEach(langName => {
        const text = textByLang(langObj, propName, langName);

        linksObj[langName] = `${pathStr}/${text}${queryParams ? `?${queryParams}` : ''}`;
      });

      setLangLinks(linksObj);
    }
  }, [langObj]);

  return { langModel: langLinks };
};

export default useLangLinks;
